import bilAPI from "../api";

export const getAcademicYears = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/core/academic_year/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
